import { TWENTIETH_CONGRESS } from "../utility/constants";
import api from "./api";

const navbarSearch = (inputValue, filter, callback) => {
  api({
    Method: "GET",
    Url: `/dashboard/search?filter=${filter}&search=${inputValue}`,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];

        callback(
          data?.map((item) => ({
            ...item,
            label: item?.name,
            value: item?.id,
          }))
        );
      }
    },
    ResponseFailCallback: () => {
      callback([]);
    },
  });
};

const congressmanSearch = ({ inputValue, callback, isLegacyData }) => {
  const url =
    isLegacyData === true
      ? `/congressman?search=${inputValue}`
      : `/congressman?search=${inputValue}&congress=${TWENTIETH_CONGRESS}`;

  api({
    Method: "GET",
    Url: url,
    ResponseSuccessCallback: (response) => {
      if (response && response?.data) {
        const data = response?.data?.length !== 0 ? response?.data : [];

        callback(
          data?.map((item) => ({
            ...item,
            label: item?.name,
            value: item?.id,
          }))
        );
      }
    },
    ResponseFailCallback: () => {
      callback([]);
    },
  });
};

export { navbarSearch, congressmanSearch };
